import { render, staticRenderFns } from "./co-applicants-info-loader.vue?vue&type=template&id=312d49a6"
import script from "./co-applicants-info-loader.vue?vue&type=script&lang=js"
export * from "./co-applicants-info-loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports